<script lang="ts" setup>
import { computed } from "vue";
import type { MpfHintProps } from "./MpfHint.props";
import { mpfHintDefaults } from "./MpfHint.props";
import "./MpfHint.scss";

const props = withDefaults(defineProps<MpfHintProps>(), mpfHintDefaults);

defineOptions({
  name: "MpfHint",
});

const hasHint = computed(() => !!props.hint?.trim());
const tag = computed(() => props.as || "div");
const classes = computed(() =>
  ["mpf-hint", props.className].filter(Boolean),
);
</script>

<template>
  <component
    v-if="hasHint"
    :is="tag"
    :id="id"
    :class="classes"
  >
    {{ hint }}
  </component>
</template>
